module.exports = __webpack_public_path__ + "static/img/Frame 1848.3dcf600.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-live/swiper1/Frame 1848.png
// module id = ykyV
// module chunks = 12